import React from "react";
import styles from "./Offcanvar.module.scss";

interface OffcanvasProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Offcanvas: React.FC<OffcanvasProps> = ({ isOpen, onClose, children }) => {
  return (
    <div
      className={`${styles.offcanvasOverlay} ${isOpen ? styles.open : ""}`}
      onClick={onClose}
    >
      <div
        className={`${styles.offcanvas} ${isOpen ? styles.open : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={styles.closeButton} onClick={onClose}>
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

export default Offcanvas;
